import React from "react";
import { Formik } from "formik";
import NewFormField from "../../../common/layout/form/NewFormField";
import NewFormCheckbox from "../../../common/layout/form/NewFormCheckbox";
import ActivityIndicator from "../../../common/layout/ActivityIndicator";
import MessageContainer from "../../../auth/components/register/forms/MessageContainer";
import { DefaultButton, IButtonStyles, mergeStyles, PrimaryButton } from "office-ui-fabric-react";
import { useTranslation } from 'react-i18next';

const buttonS: Partial<IButtonStyles> = {
  root: {
    marginRight: "20px",
  },
};

const btns = mergeStyles({
  position: "absolute",
  bottom: 30,
  left: 40,
});

export interface OperatorFormProps {
  initValues: any;
  handleSubmit: any;
  cancelForm: any;
  loading: boolean;
  selectedOperator: any;
}

const OperatorForm: React.FC<OperatorFormProps> = ({
  initValues,
  handleSubmit,
  cancelForm,
  loading,
}) => {
  const { t } = useTranslation('admin');
  return (
    <Formik initialValues={initValues} onSubmit={handleSubmit}>
      {({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <div>
            <NewFormField name="name" label={t('operators.form.name') as string} />
          </div>
          <NewFormCheckbox name="isActive" label={t('operators.form.isActive') as string} />
          <div className={btns}>
            <PrimaryButton text={!Object.keys(initValues).length ? t('operators.form.add') as string : t('operators.form.save') as string} type="submit" styles={buttonS} />
            <DefaultButton text={t('operators.form.cancel') as string} type="reset" onClick={cancelForm} />
          </div>
          {loading ? <ActivityIndicator /> : <MessageContainer />}
        </form>
      )}
    </Formik>
  );
};

export default OperatorForm;